let sample: number;

export function getSample(): number {
    if (sample === undefined) {
        sample = Math.floor(Math.random() * 100 + 1);
    }

    return sample;
}
